export default "__VITE_ASSET__764f1bdc__"